import "jquery-toast-plugin/src/jquery.toast.js"
import "jquery-toast-plugin/src/jquery.toast.css"

export default class AUtils {
    constructor(editor) {
        this.editor = editor;
        this.options = window.AConf.options;
        this.text = window.AConf.i18n;
    }

    /**
     * 弹出模态框
     * @param {*} options
     */
    _popup(options = {}) {
        const _modalOptions = {
            title: '标题',
            innerHtml: '内容',
            hasFooter: true,
            confirm: () => {

            },
            handler: () => {
            }
        };
        let modalOptions = Object.assign(_modalOptions, options);
        if ($("#x-modal").length < 1) {
            $('body').append(`<div id="x-modal" class="x-modal">
            <div class="x-modal-frame">
            <div class="x-modal-header">
                <div class="x-modal-header-title"></div>
                <div class="x-modal-header-close">X</div>
            </div>
            <div class="x-modal-body"></div>
            <div class="x-modal-footer">
                <button type="button" class="x-modal-footer-button x-modal-footer-cancel">${this.text.button.cancel}</button>
                <button type="button" class="x-modal-footer-button x-modal-footer-confirm">${this.text.button.ok}</button>
            </div></div></div>`);
        }
        $('.x-modal-header-title').html(modalOptions.title);
        $('.x-modal-body').html(modalOptions.innerHtml);
        modalOptions.hasFooter ? $(`.x-modal-footer`).show() : $('.x-modal-footer').hide();
        $('body').addClass('no-scroll');
        modalOptions.handler();
        $('.x-modal-footer-confirm').on('click', () => {
            let flag = modalOptions.confirm();
            if (flag) {
                $('#x-modal').remove();
                $('body').removeClass('no-scroll');
            }

        });
        $('.x-modal-header-close').on('click', () => {
            $('#x-modal').remove();
            $('body').removeClass('no-scroll');
        });
        $('.x-modal-footer-cancel').on('click', () => {
            $('.x-modal-header-title').html('');
            $('.x-modal-body').html('');
            $('#x-modal').remove();
            $('body').removeClass('no-scroll');
        });
        $('#x-modal').addClass('active');
    }

    /**
     * 消息提示
     * @param string noticeText 消息文本
     * @param string noticeType 消息类型
     * @param string noticePosition 消息位置
     */
    _notice(noticeText, noticeType = 'success', noticePosition = 'top-center') {
        const typeMap = {
            success: '#C6D880',
            notice: '#FFD324',
            error: '#FBC2C4'
        }
        $.toast({
            text: noticeText,
            bgColor: typeMap[noticeType],
            hideAfter: 5000,
            position: noticePosition
        });
    }

    /**
     * 更新附件计数器
     */
    _updateAttacmentNumber() {
        var btn = $('#tab-files-btn'),
            balloon = $('.balloon', btn),
            count = $('#file-list li .insert').length;

        if (count > 0) {
            if (!balloon.length) {
                btn.html($.trim(btn.html()) + ' ');
                balloon = $('<span class="balloon"></span>').appendTo(btn);
            }

            balloon.html(count);
        } else if (0 == count && balloon.length > 0) {
            balloon.remove();
        }
    }

    /**
     * 复制链接
     * @param {*} item
     */
    _copyLink(item) {
        let _this = this,
            result = _this._getDetail(item.data('cid')),
            html = `<div class="params">
            <div class="input-group"><label>友好链接</label><input type="text" value="${result.permalink}" /><span class="x-btn x-btn-primary copy">${this.text.operate.copy}</span></div>
            <div class="input-group"><label>下载链接</label><input type="text" value="${result.downloadUrl}" /><span class="x-btn x-btn-primary copy">${this.text.operate.copy}</span></div>
            <div class="input-group"><label>实际链接</label><input type="text" value="${result.realUrl}" /><span class="x-btn x-btn-primary copy">${this.text.operate.copy}</span></div>
            </div>`;

        _this._popup({
            title: _this.text.button.copyLink,
            innerHtml: html,
            hasFooter: false,
            handler: () => {
                $('.x-modal-body .params input').attr("readonly", "readonly");
                $('.x-modal-body .params .x-btn.copy').click(function () {
                    var input = $(this).parent().find('input').eq(0);
                    input.attr("readonly", false);
                    input.select();
                    if (document.execCommand('copy')) {
                        _this._notice(_this.text.status.copySuccess, "success");
                    } else {
                        _this._notice(_this.text.status.copyFailed, "error");
                    }
                    input.blur();
                    input.attr("readonly", true);
                });
            }
        });
    }

    /**
     * 插入附件到编辑器
     * @param {*} item
     */
    _insert(item) {
        if (item.data('image')) {
            this.editor.replaceSelection(this.options.insertImageTemplate.replace('{name}', item.find('.insert').text()).replace('{url}', item.data('url')));
        } else {
            this.editor.replaceSelection('[attach]' + item.data('cid') + '[/attach]');
        }
    }

    /**
     * 绑定按钮点击事件
     * @param {*} item
     */
    _attachClickEvent(item) {
        let _this = this;
        $(item).find('.accessories').on('click', el => {
            let target = $(el.target);
            _this._handleButtonsClick(target);
        });
    }

    /**
     * 关联删除事件
     * @param {*} el
     */
    _attachCustomDeleteEvent(el) {
        let file = $('a.insert', el).text(),
            _this = this;
        $('.delete', el).on('click', () => {
            if (confirm(_this.text.status.confirmDelete.replace('%s', file))) {
                let cid = el.data('cid');
                $.ajax({
                    url: window.AConf.options.api.del,
                    type: "POST",
                    data: {'cid': cid},
                    dataType: "json",
                    success: function (result) {
                        if (result && result.status && result.status == 200) {
                            $(el).fadeOut(function () {
                                $(this).remove();
                                _this._updateAttacmentNumber();
                            });
                        }
                        if (result.msg) {
                            _this._notice(result.msg, result.status == 200 ? 'success' : 'error');
                        } else {
                            _this._notice(this.text.status.unknownError, 'error');
                        }
                    }
                });
            }
            return false;
        });
    }

    /**
     * 处理按钮点击事件
     * @param {*} el
     */
    _handleButtonsClick(button) {
        let item = button.parents('li'),
            _this = this;
        if (button.data('trigger') == 'copy-link') {
            _this._copyLink(item);
        } else if (button.data('trigger') == 'payment') {
            _this._payment(item);
        } else if (button.data('trigger') == 'modify') {
            _this._modify(item);
        } else if (button.data('trigger') == 'insert') {
            _this._insert(item);
        }
    }

    _payment(button) {
        let _this = this,
            detail = _this._getPayment(button.data('cid'));
        detail.post_price = parseFloat(detail.post_price) === 0.00 ? '' : detail.post_price;
        detail.post_price_for_vip = parseFloat(detail.post_price_for_vip) === 0.00 ? '' : detail.post_price_for_vip;
        detail.post_price_for_eternal = parseFloat(detail.post_price_for_eternal) === 0.00 ? '' : detail.post_price_for_eternal;
        let html = `<form class="params">
            <input type="hidden" name="post_id" value="${detail.post_id}"/>
            <select name="post_see_type">
                <option value="-1"${detail.post_see_type == -1 ? ' selected' : ''}>${this.text.payment['-1']}</option>
                <option value="0"${detail.post_see_type == 0 ? ' selected' : ''}>${this.text.payment['0']}</option>
                <option value="1"${detail.post_see_type == 1 ? ' selected' : ''}>${this.text.payment['1']}</option>
                <option value="2"${detail.post_see_type == 2 ? ' selected' : ''}>${this.text.payment['2']}</option>
                <option value="3"${detail.post_see_type == 3 ? ' selected' : ''}>${this.text.payment['3']}</option>
            </select>
            <div class="input-group"><label for="post_price">${this.text.payment.post_price}</label><input type="text" name="post_price" value="${detail.post_price}"/></div>
            <div class="input-group"><label for="post_price_for_vip">${this.text.payment.post_price_for_vip}</label><input type="text" name="post_price_for_vip" value="${detail.post_price_for_vip}"/></div>
            <div class="input-group"><label for="post_price_for_eternal">${this.text.payment.post_price_for_eternal}</label><input type="text" name="post_price_for_eternal" value="${detail.post_price_for_eternal}"/></div>
        </div>
        </form>`;
        _this._popup({
            title: _this.text.button.payment,
            innerHtml: html,
            confirm: () => {
                const modal = $('#x-modal'),
                    form = $('#x-modal .x-modal-body .params');
                let params = form.serializeArray();
                let flag = _this._checkParams(params);
                if (flag) {
                    $.ajax({
                        url: _this.options.api.setPayment,
                        type: "POST",
                        data: params,
                        dataType: "json",
                        beforeSend: function () {
                            modal.find("button").attr("disabled", "disabled");
                        },
                        complete: function () {
                            modal.remove();
                            $('body').removeClass('no-scroll');
                        },
                        success: function (result) {
                            if (result.status && result.status == 200) {
                                if (result.data) {
                                    _this._notice(result.msg, 'success');
                                } else {
                                    _this._notice(result.msg, 'notice');
                                }
                            } else {
                                if (result.msg) {
                                    _this._notice(result.msg, 'error');
                                } else {
                                    _this._notice(this.text.status.unknownError, 'error');
                                }
                            }
                        },
                    });
                }
            }
        });
    }

    /**
     * 修改附件信息
     * @param {*} button
     */
    _modify(button) {
        let _this = this,
            detail = _this._getDetail(button.data('cid'));

        if (detail.mode == 'normal') {
            _this._modifyNormal(detail);
        } else if (detail.mode == 'external') {
            _this._modifyExternal(detail);
        } else if (detail.mode == 'netdisk') {
            _this._modifyNetdisk(detail);
        }
    }

    /**
     * 检查参数
     * @param {*} params
     */
    _checkParams(params) {
        let flag = true;
        $.each(params, function (i, param) {
            let element = $(`#x-modal .params [name=${param.name}]`);
            if (element.prop('required') && param.value === "") {
                flag = false;
                element.addClass('required');
                setTimeout(function () {
                    element.removeClass('required');
                }, 800);
            }
        });
        return flag;
    }

    /**
     * 修改普通附件
     */
    _modifyNormal(detail) {
        let _this = this,
            html = `<form class="params">
            <input type="hidden" name="cid" value="${detail.cid}"/>
            <input type="hidden" name="mode" value="${detail.mode}"/>
        <div class="input-group"><label for="title">${this.text.name}<i class="key">t</i></label><input type="text" name="title" accessKey="t" value="${detail.title}" required/></div>
        <div class="input-group"><label for="slug">${this.text.link.slug}<i class="key">s</i></label><input type="text" name="slug" accessKey="s" value="${detail.slug}" required/></div>
        <div class="input-group" style="display:none"><label>${this.text.type}</label>
        <select name="image">
            <option value="true"${detail.image ? ' selected' : ''}>${this.text.image}</option>
            <option value="false"${detail.image ? '' : ' selected'}>${this.text.attach}</option>
        </select>
        </div>
        </form>`;
        _this._popup({
            title: _this.text.button.modify,
            innerHtml: html,
            confirm: () => {
                const modal = $('#x-modal'),
                    form = $('#x-modal .x-modal-body .params');
                let params = form.serializeArray();
                let flag = _this._checkParams(params);
                if (flag) {
                    $.ajax({
                        url: _this.options.api.set,
                        type: "POST",
                        data: params,
                        dataType: "json",
                        beforeSend: function () {
                            modal.find("button").attr("disabled", "disabled");
                        },
                        complete: function () {
                            modal.remove();
                            $('body').removeClass('no-scroll');
                        },
                        success: function (result) {
                            if (result.status && result.status == 200) {
                                if (result.data) {
                                    _this._notice(result.msg, 'success');
                                    let attach = $('li[data-cid=' + result.data.cid + ']', $('#file-list'));
                                    attach.find('.insert').html(result.data.title);
                                } else {
                                    _this._notice(result.msg, 'notice');
                                }
                            } else {
                                if (result.msg) {
                                    _this._notice(result.msg, 'error');
                                } else {
                                    _this._notice(this.text.status.unknownError, 'error');
                                }
                            }
                        },
                    });
                }
            }
        });
    }

    /**
     * 修改外链附件
     */
    _modifyExternal(detail) {
        let _this = this,
            html = `<form class="params">
                <input type="hidden" name="cid" value="${detail.cid}"/>
                <input type="hidden" name="mode" value="${detail.mode}"/>
            <div class="input-group"><label>${_this.text.name}</label><input type="text" name="title" value="${detail.title}" required/></div>
            <div class="input-group"><label>${_this.text.link.slug}</label><input type="text" name="slug" value="${detail.slug}" required/></div>
            <div class="input-group"><label>${_this.text.link.external}</label><input type="text" name="external" value="${detail.url}" required/></div>
            </form>`;
        _this._popup({
            title: _this.text.button.modify,
            innerHtml: html,
            confirm: () => {
                const modal = $('#x-modal'),
                    form = $('#x-modal .x-modal-body .params');
                let params = form.serializeArray();
                let flag = _this._checkParams(params);
                $.ajax({
                    url: _this.options.api.set,
                    type: "POST",
                    data: params,
                    dataType: "json",
                    beforeSend: function () {
                        modal.find("button").attr("disabled", "disabled");
                    },
                    complete: function () {
                        modal.remove();
                        $('body').removeClass('no-scroll');
                    },
                    success: function (result) {
                        if (result.status && result.status == 200) {
                            if (result.data) {
                                _this._notice(result.msg, 'success');
                                let attach = $('li[data-cid=' + result.data.cid + ']', $('#file-list'));
                                attach.find('.insert').html(result.data.title);
                                attach.attr('data-url', result.data.url);
                            } else {
                                _this._notice(result.msg, 'notice');
                            }
                        } else {
                            if (result.msg) {
                                _this._notice(result.msg, 'error');
                            } else {
                                _this._notice(this.text.status.unknownError, 'error');
                            }
                        }
                    },
                });
                return !flag;
            }
        });
    }

    /**
     * 修改网盘附件
     */
    _modifyNetdisk(detail) {
        let _this = this,
            html = `<form class="params">
                <input type="hidden" name="cid" value="${detail.cid}"/>
                <input type="hidden" name="mode" value="${detail.mode}"/>
            <div class="input-group"><label>${_this.text.name}</label><input type="text" name="title" value="${detail.title}" required/></div>
            <div class="input-group"><label>${_this.text.link.slug}</label><input type="text" name="slug" value="${detail.slug}" required/></div>
            <div class="input-group"><label>${_this.text.netdisk.link}</label><input type="text" name="link" value="${detail.url}" required /></div>
            <div class="input-group"><label>${_this.text.netdisk.token}</label><input type="text" name="token" value="${detail.token}" /></div>
            </form>`;
        _this._popup({
            title: _this.text.button.modify,
            innerHtml: html,
            confirm: () => {
                const modal = $('#x-modal'),
                    form = $('#x-modal .x-modal-body .params');
                let params = form.serializeArray();
                let flag = _this._checkParams(params);
                $.ajax({
                    url: _this.options.api.set,
                    type: "POST",
                    data: params,
                    dataType: "json",
                    beforeSend: function () {
                        modal.find("button").attr("disabled", "disabled");
                    },
                    complete: function () {
                        modal.remove();
                        $('body').removeClass('no-scroll');
                    },
                    success: function (result) {
                        if (result.status && result.status == 200) {
                            if (result.data) {
                                _this._notice(result.msg, 'success');
                                let attach = $('li[data-cid=' + result.data.cid + ']', $('#file-list'));
                                attach.find('.insert').html(result.data.title);
                                attach.attr('data-url', result.data.url);
                                if (result.data.token !== "" || result.data.token !== undefined) {
                                    attach.attr('data-token', result.data.token);
                                } else {
                                    attach.removeAttr('data-token');
                                }
                            } else {
                                _this._notice(result.msg, 'notice');
                            }
                        } else {
                            if (result.msg) {
                                _this._notice(result.msg, 'error');
                            } else {
                                _this._notice(this.text.status.unknownError, 'error');
                            }
                        }
                    },
                });
                return !flag;
            }
        });
    }


    /**
     * 附件列表添加附件
     * @param {*} data
     */
    _addAttachToList(data) {
        $(`<li data-cid="${data.cid}" data-url="${data.url}" data-image="${data.image + 0}" data-skip></li>`).appendTo('#file-list');
        let item = $(`#file-list li[data-cid="${data.cid}"]`);
        item.html(`<input type="hidden" name="attachment[]" value="${data.cid}" />
                    <a class="insert" target="_blank" href="###" title="${this.text.clickToInsert}">${data.title}</a>
                    <div class="info ">
                        ${data.size} Kb
                        <a class="file" target="_blank" href="${this.options.adminUrl}media.php?cid=${data.cid}" title="${this.text.operate.edit}">
                            <i class="i-edit"></i>
                        </a>
                        <a class="delete" href="###" title="${this.text.operate.delete}"><i class="i-delete"></i></a>
                    </div>`)
            .effect('highlight', 1000);
        this._attachCustomDeleteEvent(item);
        this._updateAttachMode(item);
        this._updateAttachItem(item);
        this._attachClickEvent(item);
        return true;
    }

    /**
     * 添加外链附件
     */
    _addExternal() {
        let _this = this,
            parent = $('input[name="cid"]').val(),
            parentInput = (parent == "") ? "" : '<input type="hidden" name="parent" value="' + parent + '" />';
        _this._popup({
            title: _this.text.operate.add + '[' + _this.text.mode.external + ']',
            innerHtml: `<form class="params">
                <input type="hidden" name="mode" value="external" />
                ${parentInput}
                <div class="input-group"><label>${_this.text.name}</label><input type="text" name="title" /></div>
                <div class="input-group"><label>${_this.text.link.slug}</label><input type="text" name="slug" /></div>
                <div class="input-group"><label>${_this.text.link.external}</label><input type="text" name="external" required="required" /></div>
                </form>`,
            confirm: () => {
                const modal = $('#x-modal'),
                    form = $('#x-modal .x-modal-body .params');
                let params = form.serializeArray(),
                    flag = _this._checkParams(params);
                if (flag) {
                    jQuery.ajaxSetup({async: false});
                    $.ajax({
                        url: _this.options.api.add,
                        type: "POST",
                        data: params,
                        dataType: "json",
                        beforeSend: function () {
                            modal.find("input").addClass("disabled")
                                .find("button").addClass("disabled")
                                .find("textarea").addClass("disabled");
                        },
                        complete: function () {
                            modal.find("input").removeClass("disabled")
                                .find("button").removeClass("disabled")
                                .find("textarea").removeClass("disabled");
                        },
                        success: function (result) {
                            if (result && result.data && result.data.cid) {
                                flag = true;
                                _this._addAttachToList(result.data);
                            } else {
                                if (result.msg) {
                                    _this._notice(result.msg, 'error');
                                } else {
                                    _this._notice(this.text.status.unknownError, 'error');
                                }
                                return false;
                            }
                        },
                    });
                    jQuery.ajaxSetup({async: true});
                }
                return flag;
            }
        });
    }

    _addNetdisk = (el) => {
        let _this = this,
            parent = $('input[name="cid"]').val(),
            parentInput = (parent == "") ? "" : '<input type="hidden" name="parent" value="' + parent + '" />';
        _this._popup({
            title: _this.text.operate.add + '[' + _this.text.mode.netdisk + ']',
            innerHtml: `<form class="params">
                <input type="hidden" name="mode" value="netdisk" />
                ${parentInput}
                <div class="input-group"><label>${_this.text.name}</label><input type="text" name="title" /></div>
                <div class="input-group"><label>${_this.text.link.slug}</label><input type="text" name="slug" /></div>
                <div class="input-group"><label>${_this.text.netdisk.link}</label><input type="text" name="link" required /></div>
                <div class="input-group"><label>${_this.text.netdisk.token}</label><input type="text" name="token" /></div>
                </div>
                </form>`,
            confirm: () => {
                const modal = $('#x-modal'),
                    form = $('#x-modal .x-modal-body .params');
                let params = form.serializeArray(),
                    flag = _this._checkParams(params);
                if (flag) {
                    jQuery.ajaxSetup({async: false});
                    $.ajax({
                        url: _this.options.api.add,
                        type: "POST",
                        data: params,
                        dataType: "json",
                        beforeSend: function () {
                            modal.find("input").addClass("disabled")
                                .find("button").addClass("disabled")
                                .find("textarea").addClass("disabled");
                        },
                        complete: function () {
                            modal.find("input").removeClass("disabled")
                                .find("button").removeClass("disabled")
                                .find("textarea").removeClass("disabled");
                        },
                        success: function (result) {
                            if (result && result.data && result.data.cid) {
                                flag = true;
                                _this._addAttachToList(result.data);
                            } else {
                                if (result.msg) {
                                    _this._notice(result.msg, 'error');
                                } else {
                                    _this._notice(this.text.status.unknownError, 'error');
                                }
                            }
                        },
                    });
                    jQuery.ajaxSetup({async: true});
                }
                return flag;
            }
        })
    }

    /**
     * 添加附件类型
     * @param {*} el
     * @param {*} isAsync
     */
    _updateAttachMode = (el) => {
        let item = $(el),
            cid = item.attr("data-cid"),
            _this = this;
        if (item.find(".accessories-mode").length == 0 && item.attr("data-cid")) {
            function callback(data) {
                item.attr('data-image', data.image + 0)
                    .attr('data-url', data.realUrl)
                    .attr('data-mode', data.mode);
                if (data.mode == "external" || data.mode == "netdisk") {
                    $('.insert', item).after(`<span class="accessories-mode">${_this.text.mode[data.mode]}</span>`);
                }
                if (data.mode == "netdisk" && data.token) {
                    item.attr('data-token', data.token);
                }
            }

            this._getDetailAsync(cid, callback);
        }
    }

    /**
     * 添加按钮
     * @param {*} el
     */
    _updateAttachItem = (el) => {
        let item = $(el),
            _this = this,
            paymentHtml = _this.options.enablePayment ? `<a title="${_this.text.button.payment}" class="accessories payment" data-trigger="payment" href="javascript:void(0);"></a>` : '';
        if (item.find('.accessories').length == 0) {
            let html = $(`<div class="accessories-group"><a title="${_this.text.button.copyLink}" class="accessories copy-link" data-trigger="copy-link" href="javascript:void(0);"></a>
            ${paymentHtml}
            <a title="${_this.text.button.modify}" class="accessories modify" data-trigger="modify" href="javascript:void(0);"></a>
            <a title="${_this.text.button.insert}" class="accessories insert-file" data-trigger="insert" href="javascript:void(0);"></a></div>`);
            item.find('.info').append(html);
        }
        if (item.data('image') && item.find('.preview').length == 0) {
            item.find('.info').before(`<div class="preview" data-trigger="insert" title="${_this.text.button.insert}"><img src="${item.data('url')}" /></div>`);
            item.find('.preview').on('click', function () {
                _this._handleButtonsClick($(this));
            });
        }
        let attr = item.attr('id');
        if (typeof attr !== 'undefined' && attr !== false && item.data('cid')) {
            // 补全属性
            item.attr('data-cid', item.data('cid'))
                .attr('data-url', item.data('url'))
                .attr('data-image', item.data('image') ? 1 : 0);
            item.find('.accessories').off('click').on('click', el => {
                let target = $(el.target);
                _this._handleButtonsClick(target);
            });
        }
        ;
    }

    /**
     * 获取附件详细信息
     * @param int cid
     */
    _getDetail(cid) {
        let data = [],
            _this = this;
        jQuery.ajaxSetup({async: false});
        $.post(_this.options.api.get, {
            'cid': cid
        }, function (result) {
            if (result.data && result.data.cid != undefined) {
                data = result.data;
            } else {
                _this._notice(result.msg, 'error');
            }
        }, "json");
        jQuery.ajaxSetup({async: true});
        return data;
    }

    /**
     * 获取附件付费信息
     * @param int cid
     */
    _getPayment(cid) {
        let data = [],
            _this = this;
        jQuery.ajaxSetup({async: false});
        $.post(_this.options.api.getPayment, {
            'cid': cid
        }, function (result) {
            if (result.data && result.data.post_id != undefined) {
                data = result.data;
            } else {
                _this._notice(result.msg, 'error');
            }
        }, "json");
        jQuery.ajaxSetup({async: true});
        return data;
    }

    /**
     * 获取附件详细信息
     * @param {*} cid
     * @param {*} callback
     */
    _getDetailAsync(cid, callback) {
        let data = [],
            _this = this;
        $.post(_this.options.api.get, {
            'cid': cid
        }, function (result) {
            if (result.data && result.data.cid != undefined) {
                callback(result.data);
            } else {
                _this._notice(result.msg, 'error');
            }
        }, "json");
    }
}
